export const NAME = 'sponsorship';

/**
 * Here goes the actionTypes
 */
export const REQUEST_ACCOUNT_GODCHILDREN = 'REQUEST_ACCOUNT_GODCHILDREN';
export const RECEIVE_ACCOUNT_GODCHILDREN = 'RECEIVE_ACCOUNT_GODCHILDREN';
export const FAILURE_ACCOUNT_GODCHILDREN = 'FAILURE_ACCOUNT_GODCHILDREN';



// WEBPACK FOOTER //
// ./src/services/account/godchildren/constants.js